import { accountApi, clearingApi } from "../config/apiConfig";

function formatDateToYYYYMMDD(date = new Date()) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${year}-${month}-${day}`;
}

function getOneYearAgoFromDate(today = new Date()) {
  const oneYearAgo = new Date(today.setFullYear(today.getFullYear() - 1));
  return formatDateToYYYYMMDD(oneYearAgo);
}

export const getAppUsersStatistics = async () => {
  try {
    const formattedStart = getOneYearAgoFromDate(); // one year ago
    const formattedEnd = formatDateToYYYYMMDD(); // end today

    const response = await accountApi.get(
      `/users/${formattedStart}/${formattedEnd}`
    );

    return response?.data || [];
  } catch (error) {
    console.error("Error in getAppUsersStatistics:", error);
    return [];
  }
};

export const getMonthlyStatistics = async (year = new Date().getFullYear()) => {
  const endpoint = `/api/v1/analytics/yearly-trends/${year}`;

  try {
    const response = await clearingApi.get(endpoint);

    return response?.data || [];
  } catch (error) {
    console.error("Error in getMonthlyStatistics:", error);
    return [];
  }
};

export const getTotalStatistics = async () => {
  const endpoint = `/api/v1/analytics/current-summary`;

  try {
    const response = await clearingApi.get(endpoint);

    return response?.data || [];
  } catch (error) {
    console.error("Error in getTotalStatistics:", error);
    return [];
  }
};
